<template>
  <div id="careersPage">
    <p>Camber is always searching for engineering professionals to be a part of our high energy team.

    Please send resumes to <a href="mailto:jobs@camberstrategic.com?Subject=Ignite%20My%20Career">jobs@camberstrategic.com</a></p>
  </div>
</template>

<script>
export default {
  name: 'CareersPage'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Pages/CareersPage.vue